module.exports = __webpack_public_path__ + "static/media/home-card4.15af206e.png";